// @flow
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { slugify } from '@finect/front-utils/slugify';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Small } from '@finect/tabular-core/Small';
import { Strong } from '@finect/tabular-core/Strong';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import type { TagType } from '../../types';
import { SideTitle } from '../';
import { shuffle } from '../../utils/shuffle';
import { RelatedQuestions, RelatedQuestionList } from './RelatedQuestions';
import { Related } from './Related';

/* eslint-disable */
export const RelatedList = styled.div`
  margin-bottom: 12px;

  ${/*sc-sel*/ RelatedQuestionList} {
    padding-top: 12px;
    padding-left: 12px;
    border-top: 1px solid ${({ theme }) => theme.borderColor};
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    margin: 12px 0;
  }

  li {
    line-height: 1.4em;
  }
`;
/* eslint-enable */
const RelatedItem = styled.div`
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-bottom: 18px;
  background: #fff;

  strong {
    display: block;
    padding-right: 24px;

    & + small {
      padding-right: 24px;
      margin-top: 6px;
    }

    &:first-letter {
      text-transform: uppercase;
    }

    a {
      color: ${({ theme }) => theme.colors.font};
    }
  }
`;

/* stylelint-disable */
const RelatedItemLink = styled(Link)`
  display: block;
  position: relative;
  color: ${({ theme }) => theme.mainColor};

  svg {
    position: absolute;
    top: ${({ main }) => (main ? '3px' : '18px')};
    right: ${({ main }) => (main ? '0' : '15px')};
  }

  & + small {
    padding-right: 24px;
    margin-top: 6px;
  }

  &:hover {
    strong,
    svg {
      color: ${({ theme }) => theme.colors.primaryL};
    }
  }
`;
/* stylelint-enable */

type Props = {
  tags: {
    [key: number]: TagType
  },
  title: string,
  ignoreId?: number,
  hide?: string,
  register?: Function
};

type State = {
  randomTags: Array<string>
};

const getRandomTags = (tags, ignoreId) => {
  const relatedTags = { ...tags };
  if (ignoreId) delete relatedTags[ignoreId];
  return shuffle(Object.keys(relatedTags)).slice(0, 5);
};

const parseDescriptionHTML = (description: string, limit: number = 78) => {
  const finaltext = description
    .replace(/<\/?(b|i|em|strong|u)>/g, '')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const truncated =
    finaltext.length > limit ? `${finaltext.slice(0, finaltext.lastIndexOf(' ', limit))}...` : finaltext;

  return <Small>{truncated}</Small>;
};

export class RandomTags extends React.Component<Props, State> {
  state = {
    randomTags: getRandomTags(this.props.tags, this.props.ignoreId)
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (this.props.ignoreId !== nextProps.ignoreId) {
      this.setState({
        randomTags: getRandomTags(nextProps.tags, nextProps.ignoreId)
      });
    }
  }

  render() {
    const { tags, title, hide, register } = this.props;
    const { randomTags } = this.state;

    return (
      <Related hide={hide}>
        <RelatedList>
          <SideTitle extraMargin>{title}</SideTitle>
          <div>
            {randomTags.map((key, index) => {
              const tag = tags[Number(key)];

              if (index === 0) {
                return (
                  <RelatedItem key={tag.id}>
                    <RelatedItemLink
                      main="true"
                      key={tag.id}
                      to={`/preguntas/temas/${tag.id}/${slugify(tag.name)}`}
                      rel="nofollow"
                    >
                      <Strong>{tag.name}</Strong>
                      <ArrowRight size="18" />
                    </RelatedItemLink>
                    {tag.description ? parseDescriptionHTML(tag.description) : null}
                    <RelatedQuestions tag={tag} register={register} />
                  </RelatedItem>
                );
              }
              return (
                <RelatedItemLink key={tag.id} to={`/preguntas/temas/${tag.id}/${slugify(tag.name)}`} rel="nofollow">
                  <RelatedItem>
                    <Strong>{tag.name}</Strong>
                    {tag.description ? parseDescriptionHTML(tag.description) : null}
                    <ArrowRight size="18" />
                  </RelatedItem>
                </RelatedItemLink>
              );
            })}
          </div>
          <Paragraph textCenter>
            <AppLink href="/preguntas/temas">
              <Small>Ver más temas</Small>
            </AppLink>
          </Paragraph>
        </RelatedList>
      </Related>
    );
  }
}
